import * as d from "react";
import o, { useRef as K, useCallback as $, useSyncExternalStore as mn, useId as he, useState as ee, useEffect as ce, createContext as pn, useMemo as fn, Children as kn, isValidElement as hn, useContext as Ln, createElement as En, useTransition as wn } from "react";
import { c as y, t as z } from "./app-a75c1d35.mjs";
import { b as Sn, u as Y } from "./useClickOutside-726e7c36.mjs";
import { I as R, W as N } from "./Icon-3122c134.mjs";
import { L as O } from "./Link-479ac100.mjs";
import yn from "react-dom";
import { u as X, j as _, P as H, c as P, d as le, a as Re, b as Cn, e as bn, f as Oe, g as He, h as ae, i as de, k as Mn } from "./index-099c513a.mjs";
import { I as xn } from "./Image-d6406817.mjs";
import { L as Nn, a as Dn, u as Ae } from "./Logo-f02d52de.mjs";
import { B as T, a as be } from "./Block-9b78bd10.mjs";
import { M as Ue, u as Me } from "./useModal-4683a76a.mjs";
import "./LinkContext-0c83848a.mjs";
import "./ImageContext-57256dc1.mjs";
import "./Image.module-8b345b58.mjs";
function Pn(e) {
  const n = K(0), t = K("init"), a = $(() => {
    const r = e?.current?.clientHeight ?? 104, s = window.scrollY - n.current;
    if (n.current = window.scrollY, window.scrollY <= r)
      return t.current = "init";
    if (s === 0)
      return t.current;
    const c = s < 0 ? "up" : "down";
    return t.current = c;
  }, [e]);
  return mn(
    In,
    a,
    () => "init"
  );
}
function In(e) {
  return window.addEventListener("scroll", e), () => window.removeEventListener("scroll", e);
}
const Tn = "rich-text", Rn = "hero__text", On = "mobile", Hn = "tablet", An = "desktop", Un = "button__text-primary", Fn = "button__title", Bn = "button__title__map", Vn = "button__heroTitle", $n = "heading__page", jn = "heading__section", Kn = "heading__menu", zn = "texts__component_title", Wn = "navigation__language-picker--dropdown__link", Gn = "texts__component_title--bold", Yn = "texts__lead_text", Xn = "page__lead_text", qn = "texts__lead_text--bold", Jn = "texts__paragraph_subtitle", Qn = "texts__paragraph_subtitle--bold", Zn = "texts__body_text", et = "texts__body_text--bold", nt = "texts__link", tt = "texts__caption", ot = "texts__caption--bold", it = "page__heading", at = "navigation__language-picker", rt = "navigation__language-picker__button", st = "navigation__language-picker--dropdown", ct = "navigation__language-picker--dropdown__heading", lt = "navigation__language-picker--dropdown__list", J = {
  richText: Tn,
  heroText: Rn,
  mobile: On,
  tablet: Hn,
  desktop: An,
  buttonTextPrimary: Un,
  buttonTitle: Fn,
  buttonTitleMap: Bn,
  buttonHeroTitle: Vn,
  headingPage: $n,
  headingSection: jn,
  headingMenu: Kn,
  textsComponentTitle: zn,
  navigationLanguagePickerDropdownLink: Wn,
  textsComponentTitleBold: Gn,
  textsLeadText: Yn,
  pageLeadText: Xn,
  textsLeadTextBold: qn,
  textsParagraphSubtitle: Jn,
  textsParagraphSubtitleBold: Qn,
  textsBodyText: Zn,
  textsBodyTextBold: et,
  textsLink: nt,
  textsCaption: tt,
  textsCaptionBold: ot,
  pageHeading: it,
  navigationLanguagePicker: at,
  navigationLanguagePickerButton: rt,
  navigationLanguagePickerDropdown: st,
  navigationLanguagePickerDropdownHeading: ct,
  navigationLanguagePickerDropdownList: lt
};
function dt({
  currentLanguage: e,
  availableLanguages: n,
  currentUrlPath: t,
  isNavigationHidden: a,
  i18n: i
}) {
  const r = he(), s = `language-picker-${r}`, c = `language-picker-button-${r}`, u = `language-picker-dropdown-${r}`, { selectLanguageLabel: g = "Select language" } = i || {}, {
    isDropdownOpen: l,
    closeDropdown: p,
    toggleDropdownOpen: v,
    buttonRef: m,
    dropdownRef: f
  } = gt(a);
  return n.length < 2 ? null : /* @__PURE__ */ o.createElement("div", { id: s, className: J.navigationLanguagePicker }, /* @__PURE__ */ o.createElement(
    "button",
    {
      id: c,
      className: y(
        J.navigationLanguagePickerButton
        // isDropdownOpen
        //   ? typography.textsLeadTextBold
        //   : typography.textsLeadText
      ),
      "aria-expanded": l,
      "aria-controls": u,
      onClick: v,
      type: "button",
      ref: m
    },
    /* @__PURE__ */ o.createElement("span", null, e.toUpperCase()),
    /* @__PURE__ */ o.createElement(R, { icon: N.GLOBE, size: 24 })
  ), /* @__PURE__ */ o.createElement(
    "div",
    {
      id: u,
      className: J.navigationLanguagePickerDropdown,
      "data-open": l,
      role: "listbox",
      "aria-activedescendant": `${u}-${e}`,
      ref: f
    },
    /* @__PURE__ */ o.createElement(
      "div",
      {
        className: y(
          z.headingSection,
          J.navigationLanguagePickerDropdownHeading
        )
      },
      g
    ),
    /* @__PURE__ */ o.createElement("ul", { className: J.navigationLanguagePickerDropdownList }, n.map((k) => /* @__PURE__ */ o.createElement(
      ut,
      {
        key: k.code,
        ...k,
        closeDropdown: p,
        currentLanguage: e,
        currentUrlPath: t,
        dropdownId: u
      }
    )))
  ));
}
function ut({
  code: e,
  label: n,
  currentLanguage: t,
  currentUrlPath: a,
  closeDropdown: i,
  dropdownId: r
}) {
  const s = `${r}-${e}`, c = e === t;
  return /* @__PURE__ */ o.createElement(
    O,
    {
      key: e,
      id: s,
      className: J.navigationLanguagePickerDropdownLink,
      "aria-selected": c,
      locale: e,
      href: a,
      disableLinkTextStyle: !0,
      role: "listitem",
      onClick: i
    },
    e.toUpperCase(),
    " - ",
    n
  );
}
function gt(e) {
  const [n, t] = ee(!1), a = $(
    () => t((c) => !c),
    []
  ), i = $(() => t(!1), []), r = K(null), s = K(null);
  return ce(() => {
    e && i();
  }, [e, i]), Sn([r, s], i), {
    isDropdownOpen: n,
    toggleDropdownOpen: a,
    closeDropdown: i,
    buttonRef: r,
    dropdownRef: s
  };
}
function Fe(e) {
  const n = d.useRef(e);
  return d.useEffect(() => {
    n.current = e;
  }), d.useMemo(() => (...t) => n.current?.(...t), []);
}
function vt(e) {
  const n = d.useRef(e);
  return d.useEffect(() => {
    n.current = e;
  }), d.useMemo(() => (...t) => n.current?.(...t), []);
}
function _t(e, n = globalThis?.document) {
  const t = vt(e);
  d.useEffect(() => {
    const a = (i) => {
      i.key === "Escape" && t(i);
    };
    return n.addEventListener("keydown", a, { capture: !0 }), () => n.removeEventListener("keydown", a, { capture: !0 });
  }, [t, n]);
}
var mt = "DismissableLayer", ue = "dismissableLayer.update", pt = "dismissableLayer.pointerDownOutside", ft = "dismissableLayer.focusOutside", xe, Be = d.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ve = d.forwardRef(
  (e, n) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      onFocusOutside: r,
      onInteractOutside: s,
      onDismiss: c,
      ...u
    } = e, g = d.useContext(Be), [l, p] = d.useState(null), v = l?.ownerDocument ?? globalThis?.document, [, m] = d.useState({}), f = X(n, (w) => p(w)), k = Array.from(g.layers), [C] = [...g.layersWithOutsidePointerEventsDisabled].slice(-1), M = k.indexOf(C), I = l ? k.indexOf(l) : -1, h = g.layersWithOutsidePointerEventsDisabled.size > 0, L = I >= M, E = Lt((w) => {
      const F = w.target, b = [...g.branches].some((B) => B.contains(F));
      !L || b || (i?.(w), s?.(w), w.defaultPrevented || c?.());
    }, v), S = Et((w) => {
      const F = w.target;
      [...g.branches].some((B) => B.contains(F)) || (r?.(w), s?.(w), w.defaultPrevented || c?.());
    }, v);
    return _t((w) => {
      I === g.layers.size - 1 && (a?.(w), !w.defaultPrevented && c && (w.preventDefault(), c()));
    }, v), d.useEffect(() => {
      if (l)
        return t && (g.layersWithOutsidePointerEventsDisabled.size === 0 && (xe = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), g.layersWithOutsidePointerEventsDisabled.add(l)), g.layers.add(l), Ne(), () => {
          t && g.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = xe);
        };
    }, [l, v, t, g]), d.useEffect(() => () => {
      l && (g.layers.delete(l), g.layersWithOutsidePointerEventsDisabled.delete(l), Ne());
    }, [l, g]), d.useEffect(() => {
      const w = () => m({});
      return document.addEventListener(ue, w), () => document.removeEventListener(ue, w);
    }, []), /* @__PURE__ */ _.jsx(
      H.div,
      {
        ...u,
        ref: f,
        style: {
          pointerEvents: h ? L ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: P(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: P(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: P(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Ve.displayName = mt;
var kt = "DismissableLayerBranch", ht = d.forwardRef((e, n) => {
  const t = d.useContext(Be), a = d.useRef(null), i = X(n, a);
  return d.useEffect(() => {
    const r = a.current;
    if (r)
      return t.branches.add(r), () => {
        t.branches.delete(r);
      };
  }, [t.branches]), /* @__PURE__ */ _.jsx(H.div, { ...e, ref: i });
});
ht.displayName = kt;
function Lt(e, n = globalThis?.document) {
  const t = Fe(e), a = d.useRef(!1), i = d.useRef(() => {
  });
  return d.useEffect(() => {
    const r = (c) => {
      if (c.target && !a.current) {
        let u = function() {
          $e(
            pt,
            t,
            g,
            { discrete: !0 }
          );
        };
        const g = { originalEvent: c };
        c.pointerType === "touch" ? (n.removeEventListener("click", i.current), i.current = u, n.addEventListener("click", i.current, { once: !0 })) : u();
      } else
        n.removeEventListener("click", i.current);
      a.current = !1;
    }, s = window.setTimeout(() => {
      n.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(s), n.removeEventListener("pointerdown", r), n.removeEventListener("click", i.current);
    };
  }, [n, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function Et(e, n = globalThis?.document) {
  const t = Fe(e), a = d.useRef(!1);
  return d.useEffect(() => {
    const i = (r) => {
      r.target && !a.current && $e(ft, t, { originalEvent: r }, {
        discrete: !1
      });
    };
    return n.addEventListener("focusin", i), () => n.removeEventListener("focusin", i);
  }, [n, t]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function Ne() {
  const e = new CustomEvent(ue);
  document.dispatchEvent(e);
}
function $e(e, n, t, { discrete: a }) {
  const i = t.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: t });
  n && i.addEventListener(e, n, { once: !0 }), a ? le(i, r) : i.dispatchEvent(r);
}
function wt(e) {
  const n = d.useRef({ value: e, previous: e });
  return d.useMemo(() => (n.current.value !== e && (n.current.previous = n.current.value, n.current.value = e), n.current.previous), [e]);
}
function W(e) {
  const n = d.useRef(e);
  return d.useEffect(() => {
    n.current = e;
  }), d.useMemo(() => (...t) => n.current?.(...t), []);
}
var St = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), yt = "VisuallyHidden", je = d.forwardRef(
  (e, n) => /* @__PURE__ */ _.jsx(
    H.span,
    {
      ...e,
      ref: n,
      style: { ...St, ...e.style }
    }
  )
);
je.displayName = yt;
var Ct = je, q = "NavigationMenu", [Le, Ke, bt] = Re(q), [ge, Mt, xt] = Re(q), [Ee, Da] = Cn(
  q,
  [bt, xt]
), [Nt, V] = Ee(q), [Dt, Pt] = Ee(q), ze = d.forwardRef(
  (e, n) => {
    const {
      __scopeNavigationMenu: t,
      value: a,
      onValueChange: i,
      defaultValue: r,
      delayDuration: s = 200,
      skipDelayDuration: c = 300,
      orientation: u = "horizontal",
      dir: g,
      ...l
    } = e, [p, v] = d.useState(null), m = X(n, (b) => v(b)), f = bn(g), k = d.useRef(0), C = d.useRef(0), M = d.useRef(0), [I, h] = d.useState(!0), [L, E] = Oe({
      prop: a,
      onChange: (b) => {
        const B = b !== "", re = c > 0;
        B ? (window.clearTimeout(M.current), re && h(!1)) : (window.clearTimeout(M.current), M.current = window.setTimeout(
          () => h(!0),
          c
        )), i?.(b);
      },
      defaultProp: r ?? "",
      caller: q
    }), S = d.useCallback(() => {
      window.clearTimeout(C.current), C.current = window.setTimeout(() => E(""), 150);
    }, [E]), w = d.useCallback(
      (b) => {
        window.clearTimeout(C.current), E(b);
      },
      [E]
    ), F = d.useCallback(
      (b) => {
        L === b ? window.clearTimeout(C.current) : k.current = window.setTimeout(() => {
          window.clearTimeout(C.current), E(b);
        }, s);
      },
      [L, E, s]
    );
    return d.useEffect(() => () => {
      window.clearTimeout(k.current), window.clearTimeout(C.current), window.clearTimeout(M.current);
    }, []), /* @__PURE__ */ _.jsx(
      We,
      {
        scope: t,
        isRootMenu: !0,
        value: L,
        dir: f,
        orientation: u,
        rootNavigationMenu: p,
        onTriggerEnter: (b) => {
          window.clearTimeout(k.current), I ? F(b) : w(b);
        },
        onTriggerLeave: () => {
          window.clearTimeout(k.current), S();
        },
        onContentEnter: () => window.clearTimeout(C.current),
        onContentLeave: S,
        onItemSelect: (b) => {
          E((B) => B === b ? "" : b);
        },
        onItemDismiss: () => E(""),
        children: /* @__PURE__ */ _.jsx(
          H.nav,
          {
            "aria-label": "Main",
            "data-orientation": u,
            dir: f,
            ...l,
            ref: m
          }
        )
      }
    );
  }
);
ze.displayName = q;
var ve = "NavigationMenuSub", It = d.forwardRef(
  (e, n) => {
    const {
      __scopeNavigationMenu: t,
      value: a,
      onValueChange: i,
      defaultValue: r,
      orientation: s = "horizontal",
      ...c
    } = e, u = V(ve, t), [g, l] = Oe({
      prop: a,
      onChange: i,
      defaultProp: r ?? "",
      caller: ve
    });
    return /* @__PURE__ */ _.jsx(
      We,
      {
        scope: t,
        isRootMenu: !1,
        value: g,
        dir: u.dir,
        orientation: s,
        rootNavigationMenu: u.rootNavigationMenu,
        onTriggerEnter: (p) => l(p),
        onItemSelect: (p) => l(p),
        onItemDismiss: () => l(""),
        children: /* @__PURE__ */ _.jsx(H.div, { "data-orientation": s, ...c, ref: n })
      }
    );
  }
);
It.displayName = ve;
var We = (e) => {
  const {
    scope: n,
    isRootMenu: t,
    rootNavigationMenu: a,
    dir: i,
    orientation: r,
    children: s,
    value: c,
    onItemSelect: u,
    onItemDismiss: g,
    onTriggerEnter: l,
    onTriggerLeave: p,
    onContentEnter: v,
    onContentLeave: m
  } = e, [f, k] = d.useState(null), [C, M] = d.useState(/* @__PURE__ */ new Map()), [I, h] = d.useState(null);
  return /* @__PURE__ */ _.jsx(
    Nt,
    {
      scope: n,
      isRootMenu: t,
      rootNavigationMenu: a,
      value: c,
      previousValue: wt(c),
      baseId: He(),
      dir: i,
      orientation: r,
      viewport: f,
      onViewportChange: k,
      indicatorTrack: I,
      onIndicatorTrackChange: h,
      onTriggerEnter: W(l),
      onTriggerLeave: W(p),
      onContentEnter: W(v),
      onContentLeave: W(m),
      onItemSelect: W(u),
      onItemDismiss: W(g),
      onViewportContentChange: d.useCallback((L, E) => {
        M((S) => (S.set(L, E), new Map(S)));
      }, []),
      onViewportContentRemove: d.useCallback((L) => {
        M((E) => E.has(L) ? (E.delete(L), new Map(E)) : E);
      }, []),
      children: /* @__PURE__ */ _.jsx(Le.Provider, { scope: n, children: /* @__PURE__ */ _.jsx(Dt, { scope: n, items: C, children: s }) })
    }
  );
}, Ge = "NavigationMenuList", Ye = d.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = V(Ge, t), r = /* @__PURE__ */ _.jsx(H.ul, { "data-orientation": i.orientation, ...a, ref: n });
    return /* @__PURE__ */ _.jsx(H.div, { style: { position: "relative" }, ref: i.onIndicatorTrackChange, children: /* @__PURE__ */ _.jsx(Le.Slot, { scope: t, children: i.isRootMenu ? /* @__PURE__ */ _.jsx(tn, { asChild: !0, children: r }) : r }) });
  }
);
Ye.displayName = Ge;
var Xe = "NavigationMenuItem", [Tt, qe] = Ee(Xe), Je = d.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, value: a, ...i } = e, r = He(), s = a || r || "LEGACY_REACT_AUTO_VALUE", c = d.useRef(null), u = d.useRef(null), g = d.useRef(null), l = d.useRef(() => {
    }), p = d.useRef(!1), v = d.useCallback((f = "start") => {
      if (c.current) {
        l.current();
        const k = me(c.current);
        k.length && ye(f === "start" ? k : k.reverse());
      }
    }, []), m = d.useCallback(() => {
      if (c.current) {
        const f = me(c.current);
        f.length && (l.current = $t(f));
      }
    }, []);
    return /* @__PURE__ */ _.jsx(
      Tt,
      {
        scope: t,
        value: s,
        triggerRef: u,
        contentRef: c,
        focusProxyRef: g,
        wasEscapeCloseRef: p,
        onEntryKeyDown: v,
        onFocusProxyEnter: v,
        onRootContentClose: m,
        onContentFocusOutside: m,
        children: /* @__PURE__ */ _.jsx(H.li, { ...i, ref: n })
      }
    );
  }
);
Je.displayName = Xe;
var _e = "NavigationMenuTrigger", Qe = d.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, disabled: a, ...i } = e, r = V(_e, e.__scopeNavigationMenu), s = qe(_e, e.__scopeNavigationMenu), c = d.useRef(null), u = X(c, s.triggerRef, n), g = an(r.baseId, s.value), l = rn(r.baseId, s.value), p = d.useRef(!1), v = d.useRef(!1), m = s.value === r.value;
  return /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
    /* @__PURE__ */ _.jsx(Le.ItemSlot, { scope: t, value: s.value, children: /* @__PURE__ */ _.jsx(on, { asChild: !0, children: /* @__PURE__ */ _.jsx(
      H.button,
      {
        id: g,
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-state": Ce(m),
        "aria-expanded": m,
        "aria-controls": l,
        ...i,
        ref: u,
        onPointerEnter: P(e.onPointerEnter, () => {
          v.current = !1, s.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: P(
          e.onPointerMove,
          ie(() => {
            a || v.current || s.wasEscapeCloseRef.current || p.current || (r.onTriggerEnter(s.value), p.current = !0);
          })
        ),
        onPointerLeave: P(
          e.onPointerLeave,
          ie(() => {
            a || (r.onTriggerLeave(), p.current = !1);
          })
        ),
        onClick: P(e.onClick, () => {
          r.onItemSelect(s.value), v.current = m;
        }),
        onKeyDown: P(e.onKeyDown, (f) => {
          const C = { horizontal: "ArrowDown", vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[r.orientation];
          m && f.key === C && (s.onEntryKeyDown(), f.preventDefault());
        })
      }
    ) }) }),
    m && /* @__PURE__ */ _.jsxs(_.Fragment, { children: [
      /* @__PURE__ */ _.jsx(
        Ct,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: s.focusProxyRef,
          onFocus: (f) => {
            const k = s.contentRef.current, C = f.relatedTarget, M = C === c.current, I = k?.contains(C);
            (M || !I) && s.onFocusProxyEnter(M ? "start" : "end");
          }
        }
      ),
      r.viewport && /* @__PURE__ */ _.jsx("span", { "aria-owns": l })
    ] })
  ] });
});
Qe.displayName = _e;
var Rt = "NavigationMenuLink", De = "navigationMenu.linkSelect", Ze = d.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, active: a, onSelect: i, ...r } = e;
    return /* @__PURE__ */ _.jsx(on, { asChild: !0, children: /* @__PURE__ */ _.jsx(
      H.a,
      {
        "data-active": a ? "" : void 0,
        "aria-current": a ? "page" : void 0,
        ...r,
        ref: n,
        onClick: P(
          e.onClick,
          (s) => {
            const c = s.target, u = new CustomEvent(De, {
              bubbles: !0,
              cancelable: !0
            });
            if (c.addEventListener(De, (g) => i?.(g), { once: !0 }), le(c, u), !u.defaultPrevented && !s.metaKey) {
              const g = new CustomEvent(oe, {
                bubbles: !0,
                cancelable: !0
              });
              le(c, g);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Ze.displayName = Rt;
var we = "NavigationMenuIndicator", Ot = d.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, i = V(we, e.__scopeNavigationMenu), r = !!i.value;
  return i.indicatorTrack ? yn.createPortal(
    /* @__PURE__ */ _.jsx(ae, { present: t || r, children: /* @__PURE__ */ _.jsx(Ht, { ...a, ref: n }) }),
    i.indicatorTrack
  ) : null;
});
Ot.displayName = we;
var Ht = d.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, ...a } = e, i = V(we, t), r = Ke(t), [s, c] = d.useState(
    null
  ), [u, g] = d.useState(null), l = i.orientation === "horizontal", p = !!i.value;
  d.useEffect(() => {
    const f = r().find((k) => k.value === i.value)?.ref.current;
    f && c(f);
  }, [r, i.value]);
  const v = () => {
    s && g({
      size: l ? s.offsetWidth : s.offsetHeight,
      offset: l ? s.offsetLeft : s.offsetTop
    });
  };
  return pe(s, v), pe(i.indicatorTrack, v), u ? /* @__PURE__ */ _.jsx(
    H.div,
    {
      "aria-hidden": !0,
      "data-state": p ? "visible" : "hidden",
      "data-orientation": i.orientation,
      ...a,
      ref: n,
      style: {
        position: "absolute",
        ...l ? {
          left: 0,
          width: u.size + "px",
          transform: `translateX(${u.offset}px)`
        } : {
          top: 0,
          height: u.size + "px",
          transform: `translateY(${u.offset}px)`
        },
        ...a.style
      }
    }
  ) : null;
}), Z = "NavigationMenuContent", en = d.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, i = V(Z, e.__scopeNavigationMenu), r = qe(Z, e.__scopeNavigationMenu), s = X(r.contentRef, n), c = r.value === i.value, u = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...a
  };
  return i.viewport ? /* @__PURE__ */ _.jsx(At, { forceMount: t, ...u, ref: s }) : /* @__PURE__ */ _.jsx(ae, { present: t || c, children: /* @__PURE__ */ _.jsx(
    nn,
    {
      "data-state": Ce(c),
      ...u,
      ref: s,
      onPointerEnter: P(e.onPointerEnter, i.onContentEnter),
      onPointerLeave: P(
        e.onPointerLeave,
        ie(i.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !c && i.isRootMenu ? "none" : void 0,
        ...u.style
      }
    }
  ) });
});
en.displayName = Z;
var At = d.forwardRef((e, n) => {
  const t = V(Z, e.__scopeNavigationMenu), { onViewportContentChange: a, onViewportContentRemove: i } = t;
  return de(() => {
    a(e.value, {
      ref: n,
      ...e
    });
  }, [e, n, a]), de(() => () => i(e.value), [e.value, i]), null;
}), oe = "navigationMenu.rootContentDismiss", nn = d.forwardRef((e, n) => {
  const {
    __scopeNavigationMenu: t,
    value: a,
    triggerRef: i,
    focusProxyRef: r,
    wasEscapeCloseRef: s,
    onRootContentClose: c,
    onContentFocusOutside: u,
    ...g
  } = e, l = V(Z, t), p = d.useRef(null), v = X(p, n), m = an(l.baseId, a), f = rn(l.baseId, a), k = Ke(t), C = d.useRef(null), { onItemDismiss: M } = l;
  d.useEffect(() => {
    const h = p.current;
    if (l.isRootMenu && h) {
      const L = () => {
        M(), c(), h.contains(document.activeElement) && i.current?.focus();
      };
      return h.addEventListener(oe, L), () => h.removeEventListener(oe, L);
    }
  }, [l.isRootMenu, e.value, i, M, c]);
  const I = d.useMemo(() => {
    const L = k().map((B) => B.value);
    l.dir === "rtl" && L.reverse();
    const E = L.indexOf(l.value), S = L.indexOf(l.previousValue), w = a === l.value, F = S === L.indexOf(a);
    if (!w && !F)
      return C.current;
    const b = (() => {
      if (E !== S) {
        if (w && S !== -1)
          return E > S ? "from-end" : "from-start";
        if (F && E !== -1)
          return E > S ? "to-start" : "to-end";
      }
      return null;
    })();
    return C.current = b, b;
  }, [l.previousValue, l.value, l.dir, k, a]);
  return /* @__PURE__ */ _.jsx(tn, { asChild: !0, children: /* @__PURE__ */ _.jsx(
    Ve,
    {
      id: f,
      "aria-labelledby": m,
      "data-motion": I,
      "data-orientation": l.orientation,
      ...g,
      ref: v,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const h = new Event(oe, {
          bubbles: !0,
          cancelable: !0
        });
        p.current?.dispatchEvent(h);
      },
      onFocusOutside: P(e.onFocusOutside, (h) => {
        u();
        const L = h.target;
        l.rootNavigationMenu?.contains(L) && h.preventDefault();
      }),
      onPointerDownOutside: P(e.onPointerDownOutside, (h) => {
        const L = h.target, E = k().some((w) => w.ref.current?.contains(L)), S = l.isRootMenu && l.viewport?.contains(L);
        (E || S || !l.isRootMenu) && h.preventDefault();
      }),
      onKeyDown: P(e.onKeyDown, (h) => {
        const L = h.altKey || h.ctrlKey || h.metaKey;
        if (h.key === "Tab" && !L) {
          const S = me(h.currentTarget), w = document.activeElement, F = S.findIndex((re) => re === w), B = h.shiftKey ? S.slice(0, F).reverse() : S.slice(F + 1, S.length);
          ye(B) ? h.preventDefault() : r.current?.focus();
        }
      }),
      onEscapeKeyDown: P(e.onEscapeKeyDown, (h) => {
        s.current = !0;
      })
    }
  ) });
}), Se = "NavigationMenuViewport", Ut = d.forwardRef((e, n) => {
  const { forceMount: t, ...a } = e, r = !!V(Se, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ _.jsx(ae, { present: t || r, children: /* @__PURE__ */ _.jsx(Ft, { ...a, ref: n }) });
});
Ut.displayName = Se;
var Ft = d.forwardRef((e, n) => {
  const { __scopeNavigationMenu: t, children: a, ...i } = e, r = V(Se, t), s = X(n, r.onViewportChange), c = Pt(
    Z,
    e.__scopeNavigationMenu
  ), [u, g] = d.useState(null), [l, p] = d.useState(null), v = u ? u?.width + "px" : void 0, m = u ? u?.height + "px" : void 0, f = !!r.value, k = f ? r.value : r.previousValue;
  return pe(l, () => {
    l && g({ width: l.offsetWidth, height: l.offsetHeight });
  }), /* @__PURE__ */ _.jsx(
    H.div,
    {
      "data-state": Ce(f),
      "data-orientation": r.orientation,
      ...i,
      ref: s,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !f && r.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": v,
        "--radix-navigation-menu-viewport-height": m,
        ...i.style
      },
      onPointerEnter: P(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: P(e.onPointerLeave, ie(r.onContentLeave)),
      children: Array.from(c.items).map(([M, { ref: I, forceMount: h, ...L }]) => {
        const E = k === M;
        return /* @__PURE__ */ _.jsx(ae, { present: h || E, children: /* @__PURE__ */ _.jsx(
          nn,
          {
            ...L,
            ref: Mn(I, (S) => {
              E && S && p(S);
            })
          }
        ) }, M);
      })
    }
  );
}), Bt = "FocusGroup", tn = d.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = V(Bt, t);
    return /* @__PURE__ */ _.jsx(ge.Provider, { scope: t, children: /* @__PURE__ */ _.jsx(ge.Slot, { scope: t, children: /* @__PURE__ */ _.jsx(H.div, { dir: i.dir, ...a, ref: n }) }) });
  }
), Pe = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], Vt = "FocusGroupItem", on = d.forwardRef(
  (e, n) => {
    const { __scopeNavigationMenu: t, ...a } = e, i = Mt(t), r = V(Vt, t);
    return /* @__PURE__ */ _.jsx(ge.ItemSlot, { scope: t, children: /* @__PURE__ */ _.jsx(
      H.button,
      {
        ...a,
        ref: n,
        onKeyDown: P(e.onKeyDown, (s) => {
          if (["Home", "End", ...Pe].includes(s.key)) {
            let u = i().map((p) => p.ref.current);
            if ([r.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(s.key) && u.reverse(), Pe.includes(s.key)) {
              const p = u.indexOf(s.currentTarget);
              u = u.slice(p + 1);
            }
            setTimeout(() => ye(u)), s.preventDefault();
          }
        })
      }
    ) });
  }
);
function me(e) {
  const n = [], t = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const i = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || i ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); )
    n.push(t.currentNode);
  return n;
}
function ye(e) {
  const n = document.activeElement;
  return e.some((t) => t === n ? !0 : (t.focus(), document.activeElement !== n));
}
function $t(e) {
  return e.forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((n) => {
      const t = n.dataset.tabindex;
      n.setAttribute("tabindex", t);
    });
  };
}
function pe(e, n) {
  const t = W(n);
  de(() => {
    let a = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(a), a = window.requestAnimationFrame(t);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(a), i.unobserve(e);
      };
    }
  }, [e, t]);
}
function Ce(e) {
  return e ? "open" : "closed";
}
function an(e, n) {
  return `${e}-trigger-${n}`;
}
function rn(e, n) {
  return `${e}-content-${n}`;
}
function ie(e) {
  return (n) => n.pointerType === "mouse" ? e(n) : void 0;
}
var sn = ze, cn = Ye, ln = Je, dn = Qe, j = Ze, un = en;
const jt = "navigation__links", Kt = "desktop", zt = "navigation__links__list", Wt = "navigation__links__item", Gt = "navigation__links__link", Yt = "navigation__links__trigger", Xt = "navigation__links__link--selected", qt = "navigation__links__trigger--selected", Jt = "navigation__links__trigger__arrow", Qt = "navigation__links__content", Zt = "navigation__links__dropdown", eo = "navigation__links__dropdown__header", no = "navigation__links__dropdown__header__link", to = "navigation__links__dropdown__header__separator", oo = "navigation__links__dropdown__body", io = "navigation__links__dropdown__section", ao = "navigation__links__dropdown__section__link", ro = "navigation__links__dropdown__list", so = "navigation__links__dropdown__list__item", co = "navigation__links__dropdown__sub_link", lo = "slideDown", x = {
  navigationLinks: jt,
  desktop: Kt,
  navigationLinksList: zt,
  navigationLinksItem: Wt,
  navigationLinksLink: Gt,
  navigationLinksTrigger: Yt,
  navigationLinksLinkSelected: Xt,
  navigationLinksTriggerSelected: qt,
  navigationLinksTriggerArrow: Jt,
  navigationLinksContent: Qt,
  navigationLinksDropdown: Zt,
  navigationLinksDropdownHeader: eo,
  navigationLinksDropdownHeaderLink: no,
  navigationLinksDropdownHeaderSeparator: to,
  navigationLinksDropdownBody: oo,
  navigationLinksDropdownSection: io,
  navigationLinksDropdownSectionLink: ao,
  navigationLinksDropdownList: ro,
  navigationLinksDropdownListItem: so,
  navigationLinksDropdownSubLink: co,
  slideDown: lo
};
function uo({
  links: e,
  isNavigationHidden: n,
  currentPageId: t
}) {
  const [a, i] = ee(""), r = $((s) => {
    i(s);
  }, []);
  return n ? /* @__PURE__ */ o.createElement(
    "nav",
    {
      className: x.navigationLinks,
      "data-testid": "navigation-links"
    }
  ) : /* @__PURE__ */ o.createElement(
    sn,
    {
      className: x.navigationLinks,
      "data-testid": "navigation-links",
      value: a,
      onValueChange: r
    },
    /* @__PURE__ */ o.createElement(cn, { className: x.navigationLinksList }, e.map((s) => /* @__PURE__ */ o.createElement(
      ln,
      {
        key: s.id,
        value: s.id,
        className: x.navigationLinksItem
      },
      s.subPages && s.subPages.length > 0 ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
        dn,
        {
          className: y(
            x.navigationLinksTrigger,
            (t === s.id || a === s.id) && x.navigationLinksTriggerSelected
          ),
          onPointerMove: (c) => c.preventDefault(),
          onPointerLeave: (c) => c.preventDefault()
        },
        s.title,
        /* @__PURE__ */ o.createElement(
          R,
          {
            className: x.navigationLinksTriggerArrow,
            icon: N.CHEVRON_DOWN,
            size: 16
          }
        )
      ), /* @__PURE__ */ o.createElement(
        un,
        {
          className: x.navigationLinksContent,
          onPointerLeave: (c) => c.preventDefault()
        },
        /* @__PURE__ */ o.createElement(go, { link: s })
      )) : /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
        O,
        {
          href: s.href,
          locale: s.locale,
          target: s.target,
          className: y(
            x.navigationLinksLink,
            t === s.id && x.navigationLinksLinkSelected
          ),
          disableLinkTextStyle: !0
        },
        s.title
      ))
    )))
  );
}
function go({ link: e }) {
  return /* @__PURE__ */ o.createElement("div", { className: x.navigationLinksDropdown }, /* @__PURE__ */ o.createElement("div", { className: x.navigationLinksDropdownHeader }, /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
    O,
    {
      href: e.href,
      locale: e.locale,
      target: e.target,
      className: x.navigationLinksDropdownHeaderLink,
      disableLinkTextStyle: !0
    },
    /* @__PURE__ */ o.createElement("span", null, e.title),
    /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 40 })
  )), /* @__PURE__ */ o.createElement("div", { className: x.navigationLinksDropdownHeaderSeparator })), /* @__PURE__ */ o.createElement("div", { className: x.navigationLinksDropdownBody }, e.subPages?.map((n) => /* @__PURE__ */ o.createElement(
    "div",
    {
      key: n.id,
      className: x.navigationLinksDropdownSection
    },
    /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
      O,
      {
        href: n.href,
        locale: n.locale,
        target: n.target,
        className: x.navigationLinksDropdownSectionLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ o.createElement("span", null, n.title),
      /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 20 })
    )),
    n.subPages && n.subPages.length > 0 && /* @__PURE__ */ o.createElement("ul", { className: x.navigationLinksDropdownList }, n.subPages.map((t) => /* @__PURE__ */ o.createElement(
      "li",
      {
        key: t.id,
        className: x.navigationLinksDropdownListItem
      },
      /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
        O,
        {
          href: t.href,
          locale: t.locale,
          target: t.target,
          className: x.navigationLinksDropdownSubLink,
          disableLinkTextStyle: !0
        },
        /* @__PURE__ */ o.createElement("span", null, t.title),
        /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 20 })
      ))
    )))
  ))));
}
const vo = "navigation__header", _o = "navigation__header--modal-open", mo = "desktop", po = "navigation__header--visible", fo = "navigation__header--show", ko = "animateShow", ho = "navigation__header--hide", Lo = "animateHide", Eo = "navigation__header--employers", wo = "navigation__header__content", So = "navigation__header__logo", yo = "navigation__header__actions", Co = "navigation__header__search", bo = "navigation__header__menu", Mo = "navigation__header__search--employers", xo = "navigation__header__menu--employers", No = "navigation__header__saved_items_link", Do = "navigation__header__saved_items_link__with-dot", A = {
  navigationHeader: vo,
  navigationHeaderModalOpen: _o,
  desktop: mo,
  navigationHeaderVisible: po,
  navigationHeaderShow: fo,
  animateShow: ko,
  navigationHeaderHide: ho,
  animateHide: Lo,
  navigationHeaderEmployers: Eo,
  navigationHeaderContent: wo,
  navigationHeaderLogo: So,
  navigationHeaderActions: yo,
  navigationHeaderSearch: Co,
  navigationHeaderMenu: bo,
  navigationHeaderSearchEmployers: Mo,
  navigationHeaderMenuEmployers: xo,
  navigationHeaderSavedItemsLink: No,
  navigationHeaderSavedItemsLinkWithDot: Do
}, fe = "Contact-us", Po = "contact__us", Io = "contact__us__list", To = "contact__us__trigger", Ro = "contact__us__link", Oo = "contact__us__trigger--selected", Ho = "contact__us__link--selected", Ao = "contact__us__content", Uo = "contact__us__dropdown", Fo = "desktop", Bo = "contact__us__dropdown__header", Vo = "contact__us__dropdown__header__link", $o = "contact__us__dropdown__header__separator", jo = "contact__us__dropdown__body", Ko = "contact__us__dropdown__section", zo = "contact__us__dropdown__section__link", Wo = "contact__us__dropdown__featured", Go = "contact__us__dropdown__featured__image", Yo = "contact__us__dropdown__featured__link", D = {
  contactUs: Po,
  contactUsList: Io,
  contactUsTrigger: To,
  contactUsLink: Ro,
  contactUsTriggerSelected: Oo,
  contactUsLinkSelected: Ho,
  contactUsContent: Ao,
  contactUsDropdown: Uo,
  desktop: Fo,
  contactUsDropdownHeader: Bo,
  contactUsDropdownHeaderLink: Vo,
  contactUsDropdownHeaderSeparator: $o,
  contactUsDropdownBody: jo,
  contactUsDropdownSection: Ko,
  contactUsDropdownSectionLink: zo,
  contactUsDropdownFeatured: Wo,
  contactUsDropdownFeaturedImage: Go,
  contactUsDropdownFeaturedLink: Yo
}, Ie = "contact";
function Xo({
  links: e,
  isContactUsHidden: n,
  i18n: t,
  currentPageId: a
}) {
  const [i, r] = ee(""), s = $((l) => {
    r(l);
  }, []), c = e[0], u = c?.subPages != null && c.subPages.length > 0, g = i === Ie || a === c?.id;
  return n ? /* @__PURE__ */ o.createElement("div", { className: D.contactUs }) : /* @__PURE__ */ o.createElement(
    sn,
    {
      className: D.contactUs,
      value: i,
      onValueChange: s,
      "aria-label": `${c?.title || "Contact us"} menu`
    },
    /* @__PURE__ */ o.createElement(cn, { className: D.contactUsList }, /* @__PURE__ */ o.createElement(ln, { value: Ie }, u ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
      dn,
      {
        className: y(
          D.contactUsTrigger,
          g && D.contactUsTriggerSelected
        ),
        "aria-label": c?.title || "Contact us",
        onPointerMove: (l) => l.preventDefault(),
        onPointerLeave: (l) => l.preventDefault()
      },
      /* @__PURE__ */ o.createElement(R, { icon: N.CONTACT, size: 24 })
    ), /* @__PURE__ */ o.createElement(
      un,
      {
        className: D.contactUsContent,
        onPointerLeave: (l) => l.preventDefault()
      },
      /* @__PURE__ */ o.createElement(
        qo,
        {
          link: c,
          featured: c.featured,
          i18n: t
        }
      )
    )) : /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
      O,
      {
        href: c?.href,
        locale: c?.locale,
        target: c?.target,
        className: y(
          D.contactUsLink,
          g && D.contactUsLinkSelected
        ),
        disableLinkTextStyle: !0,
        title: c?.title,
        "aria-label": c?.title || "Contact us"
      },
      /* @__PURE__ */ o.createElement(R, { icon: N.CONTACT, size: 24 })
    ))))
  );
}
function qo({
  link: e,
  featured: n,
  i18n: t
}) {
  const a = Y();
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      className: y(
        D.contactUsDropdown,
        a && D.contactUsDropdownEmployer
      )
    },
    /* @__PURE__ */ o.createElement("div", { className: D.contactUsDropdownHeader }, /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
      O,
      {
        href: e.href,
        locale: e.locale,
        target: e.target,
        className: D.contactUsDropdownHeaderLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ o.createElement("span", null, e.title),
      /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 40 })
    )), /* @__PURE__ */ o.createElement("div", { className: D.contactUsDropdownHeaderSeparator })),
    /* @__PURE__ */ o.createElement("div", { className: D.contactUsDropdownBody }, e.subPages?.map((i) => /* @__PURE__ */ o.createElement("div", { key: i.id, className: D.contactUsDropdownSection }, /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
      O,
      {
        href: i.href,
        locale: i.locale,
        target: i.target,
        className: D.contactUsDropdownSectionLink,
        disableLinkTextStyle: !0
      },
      /* @__PURE__ */ o.createElement("span", null, i.title),
      /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 20 })
    )))), n ? /* @__PURE__ */ o.createElement(Jo, { ...n, i18n: t }) : null)
  );
}
function Jo({
  image: e,
  linkUrl: n,
  title: t,
  i18n: a
}) {
  const { featureArticleText: i = "Feature article", readMoreText: r = "Read more" } = a ?? {};
  return /* @__PURE__ */ o.createElement("div", { className: D.contactUsDropdownFeatured }, /* @__PURE__ */ o.createElement(
    xn,
    {
      ...e,
      className: D.contactUsDropdownFeaturedImage
    }
  ), /* @__PURE__ */ o.createElement("span", null, i, ": ", t), /* @__PURE__ */ o.createElement(j, { asChild: !0 }, /* @__PURE__ */ o.createElement(
    O,
    {
      href: n,
      className: D.contactUsDropdownFeaturedLink
    },
    r
  )));
}
const Qo = "top-bar", Zo = "top-bar__switchLinks", ei = "top-bar__link", ni = "top-bar__link--active", te = {
  topBar: Qo,
  topBarSwitchLinks: Zo,
  topBarLink: ei,
  topBarLinkActive: ni
}, ti = (e) => {
  const { switchLinks: n } = e;
  return /* @__PURE__ */ o.createElement("section", { className: te.topBar }, /* @__PURE__ */ o.createElement("nav", { className: te.topBarSwitchLinks }, n.map((t, a) => /* @__PURE__ */ o.createElement(
    O,
    {
      key: t.id,
      href: t.href,
      locale: t.locale,
      className: y(
        te.topBarLink,
        t.isActive && te.topBarLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0
    },
    a === 0 ? /* @__PURE__ */ o.createElement(R, { icon: N.EMPLOYEE }) : /* @__PURE__ */ o.createElement(R, { icon: N.EMPLOYER }),
    /* @__PURE__ */ o.createElement("span", null, t.title)
  ))));
};
function oi(e) {
  const {
    isSearchDisabled: n,
    links: t,
    logoHref: a,
    onLogoClick: i,
    languagePickerOptions: r,
    isSearchOpen: s,
    onSearchClick: c,
    isMenuOpen: u,
    onMenuClick: g,
    i18n: l,
    switchLinks: p,
    currentPageId: v
  } = e, { headerRef: m, headerClassName: f, isHeaderHidden: k } = si(), C = Y(), M = t?.filter((I) => I?.id === fe) || [];
  return /* @__PURE__ */ o.createElement(
    T,
    {
      as: "header",
      blockRef: m,
      className: y(
        f,
        (u || s) && A.navigationHeaderModalOpen
      ),
      "data-testid": "navigation",
      topPadding: T.Padding.NONE,
      bottomPadding: T.Padding.NONE
    },
    /* @__PURE__ */ o.createElement(ti, { switchLinks: p }),
    /* @__PURE__ */ o.createElement(T.Content, { className: A.navigationHeaderContent }, /* @__PURE__ */ o.createElement(ii, { onClick: i, href: a }), /* @__PURE__ */ o.createElement(
      uo,
      {
        links: t?.filter((I) => I?.id !== fe),
        isNavigationHidden: k,
        currentPageId: v
      }
    ), /* @__PURE__ */ o.createElement("div", { className: A.navigationHeaderActions }, C && M.length > 0 && /* @__PURE__ */ o.createElement(
      Xo,
      {
        links: M,
        isContactUsHidden: k,
        i18n: l,
        currentPageId: v
      }
    ), r ? /* @__PURE__ */ o.createElement(
      dt,
      {
        ...r,
        isNavigationHidden: k,
        i18n: l
      }
    ) : null, n ? null : /* @__PURE__ */ o.createElement(
      ai,
      {
        isSearchOpen: s,
        onSearchClick: c,
        label: l?.searchLabel,
        closeLabel: l?.closeSearchLabel
      }
    ), /* @__PURE__ */ o.createElement(ri, { isMenuOpen: u, onMenuClick: g })))
  );
}
function ii({
  href: e,
  onClick: n
}) {
  const t = Y();
  return /* @__PURE__ */ o.createElement(
    O,
    {
      href: e,
      className: A.navigationHeaderLogo,
      disableLinkTextStyle: !0,
      "data-testid": "navigation-logo",
      title: "Work in Finland logo",
      onClick: n
    },
    /* @__PURE__ */ o.createElement(Nn, { color: t ? "secondary" : "primary" })
  );
}
function ai({
  isSearchOpen: e,
  onSearchClick: n,
  label: t = "Search",
  closeLabel: a = "Close search"
}) {
  const i = Y(), r = e ? a : t;
  return /* @__PURE__ */ o.createElement(
    "button",
    {
      type: "button",
      title: r,
      "aria-label": r,
      className: y(
        A.navigationHeaderSearch,
        i && A.navigationHeaderSearchEmployers
      ),
      onClick: n
    },
    /* @__PURE__ */ o.createElement(R, { icon: e ? N.CLOSE : N.SEARCH, size: 24 })
  );
}
function ri({
  isMenuOpen: e,
  onMenuClick: n
}) {
  const t = Y();
  return /* @__PURE__ */ o.createElement(
    "button",
    {
      type: "button",
      title: "Menu",
      className: y(
        A.navigationHeaderMenu,
        t && A.navigationHeaderMenuEmployers
      ),
      onClick: n
    },
    /* @__PURE__ */ o.createElement(R, { icon: e ? N.CLOSE : N.HAMBURGER, size: 20 })
  );
}
function si() {
  const e = K(null), n = Pn(e), t = Y(), a = n === "init", i = n === "down", r = n === "up", s = y(
    A.navigationHeader,
    z.textsLeadText,
    t && A.navigationHeaderEmployers,
    a && A.navigationHeaderVisible,
    r && A.navigationHeaderShow,
    i && A.navigationHeaderHide
  );
  return { headerRef: e, headerClassName: s, isHeaderHidden: i };
}
const ci = "accordion", li = "accordion__item", di = "accordion__item__heading", ui = "active", gi = "accordion__item__content", vi = "accordion__item__content--expanded", ne = {
  accordion: ci,
  accordionItem: li,
  accordionItemHeading: di,
  active: ui,
  accordionItemContent: gi,
  accordionItemContentExpanded: vi
}, gn = pn(void 0);
function _i(e = {}, n) {
  const { collapsible: t = !1, multiple: a = !1, defaultActiveId: i } = e, [r, s] = ee(
    () => se(e)
  ), c = fn(() => (kn.map(n, (m) => {
    if (hn(m))
      return m.props.id;
  }) || []).filter(Boolean), [n]), u = $(
    (v) => {
      s((m) => a ? m.includes(v) ? !t && m.length === 1 ? m : m.filter((f) => f !== v) : [...m, v] : t ? m.includes(v) ? [] : [v] : [v]);
    },
    [t, a]
  ), g = $(() => {
    s(se({ defaultActiveId: i, collapsible: t }));
  }, [i, t]), l = $(
    () => s(
      t ? [] : se({ defaultActiveId: i, collapsible: t })
    ),
    [i, t]
  ), p = $(() => {
    a && s(c);
  }, [a, c]);
  return { activeIds: r, toggleId: u, resetIds: g, collapseAll: l, expandAll: p };
}
function se({
  defaultActiveId: e,
  collapsible: n,
  allIds: t = []
} = {}) {
  if (e)
    return [e];
  if (n)
    return [];
  const a = t[0];
  return a ? [a] : [];
}
function vn({
  id: e,
  heading: n,
  children: t,
  className: a,
  disabled: i
}) {
  const r = Ln(gn);
  if (!r)
    throw new Error("Accordion.Item must be used within Accordion");
  const { activeIds: s, toggleId: c, id: u } = r, g = s.includes(e), l = {
    expanded: g,
    toggleItem: () => c(e)
  }, p = u + "-item-" + e, v = u + "-item-" + e + "-label", m = u + "-item-" + e + "-content";
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      id: p,
      "aria-expanded": g,
      className: y(ne.accordionItem),
      "data-testid": "accordion-item"
    },
    /* @__PURE__ */ o.createElement(
      "button",
      {
        id: v,
        className: y(
          ne.accordionItemHeading,
          g && "active",
          i && "disabled"
        ),
        onClick: () => c(e),
        disabled: i,
        "aria-controls": m,
        "aria-expanded": g,
        "data-testid": "accordion-toggler"
      },
      typeof n != "string" ? En(n, l) : n
    ),
    /* @__PURE__ */ o.createElement(
      "div",
      {
        id: m,
        className: y(
          ne.accordionItemContent,
          g && ne.accordionItemContentExpanded,
          a
        ),
        role: "region",
        "aria-labelledby": v,
        "data-testid": "accordion-item-content-expanded"
      },
      t
    )
  );
}
function ke({
  className: e,
  children: n,
  collapsible: t,
  multiple: a,
  defaultActiveId: i,
  ...r
}) {
  Dn(n, vn, "Accordion");
  const s = he(), c = _i(
    {
      collapsible: t,
      multiple: a,
      defaultActiveId: i
    },
    n
  );
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      className: y(ne.accordion, e),
      ...r,
      "data-testid": "accordion"
    },
    /* @__PURE__ */ o.createElement(
      gn.Provider,
      {
        value: { ...c, id: r.id || s }
      },
      n
    )
  );
}
ke.Item = vn;
const mi = "navigation__switch_link", pi = "navigation__links_section", fi = "navigation__links_section--mobile-only", ki = "desktop", hi = "navigation__links_section__link", Li = "navigation__links_section__link--primary", Ei = "navigation__links_section__link--secondary", wi = "navigation__links_section__link--mobile-only", Si = "navigation__modal", Q = {
  navigationSwitchLink: mi,
  navigationLinksSection: pi,
  navigationLinksSectionMobileOnly: fi,
  desktop: ki,
  navigationLinksSectionLink: hi,
  navigationLinksSectionLinkPrimary: Li,
  navigationLinksSectionLinkSecondary: Ei,
  navigationLinksSectionLinkMobileOnly: wi,
  navigationModal: Si
};
function yi(e) {
  return /* @__PURE__ */ o.createElement(
    "nav",
    {
      key: e.id,
      className: y(
        Q.navigationLinksSection,
        e.isMobileOnly && Q.navigationLinksSectionMobileOnly
      )
    },
    /* @__PURE__ */ o.createElement(Te, { key: `${e.id}-primary`, ...e, isPrimary: !0 }),
    _n(e).map((n) => /* @__PURE__ */ o.createElement(
      Te,
      {
        key: n.id,
        ...n,
        closeMenu: e.closeMenu
      }
    ))
  );
}
function Te({
  id: e,
  href: n,
  locale: t,
  title: a,
  isPrimary: i,
  isMobileOnly: r,
  closeMenu: s
}) {
  const c = y(
    Q.navigationLinksSectionLink,
    i ? Q.navigationLinksSectionLinkPrimary : Q.navigationLinksSectionLinkSecondary,
    i ? z.textsLeadTextBold : z.textsLeadText,
    r && Q.navigationLinksSectionLinkMobileOnly
  );
  return /* @__PURE__ */ o.createElement(
    O,
    {
      key: e,
      href: n,
      locale: t,
      itemProp: "url",
      className: c,
      disableLinkTextStyle: !0,
      onClick: s
    },
    /* @__PURE__ */ o.createElement("span", { itemProp: "name" }, a),
    /* @__PURE__ */ o.createElement(R, { icon: N.ARROW_RIGHT, size: 20 })
  );
}
function _n(e) {
  return e.subPages?.flatMap((n) => [
    n,
    ..._n(n)
  ]) || [];
}
const Ci = "navigation__switch_link", bi = "navigation__links_section", Mi = "navigation__links_section--mobile-only", xi = "desktop", Ni = "navigation__links_section__link", Di = "navigation__links_section__link--primary", Pi = "navigation__links_section__link--secondary", Ii = "navigation__links_section__link--mobile-only", Ti = "navigation__modal", Ri = "navigation__menu", Oi = "navigation__menu__switchLinks", Hi = "navigation__menu__switchLinks__content", Ai = "navigation__menu__switchLinks__link", Ui = "navigation__menu__switchLinks__link--active", Fi = "navigation__menu__accordion", Bi = "navigation__menu__accordion__heading", Vi = "navigation__menu__accordion__heading__container", $i = "navigation__menu__accordion__heading__link", ji = "navigation__menu__accordion__heading__icon", Ki = "navigation__menu__accordion__content", zi = "navigation__menu__accordion__content--employers", Wi = "navigation__menu__accordion__content__container", Gi = "navigation__menu__footer", U = {
  navigationSwitchLink: Ci,
  navigationLinksSection: bi,
  navigationLinksSectionMobileOnly: Mi,
  desktop: xi,
  navigationLinksSectionLink: Ni,
  navigationLinksSectionLinkPrimary: Di,
  navigationLinksSectionLinkSecondary: Pi,
  navigationLinksSectionLinkMobileOnly: Ii,
  navigationModal: Ti,
  navigationMenu: Ri,
  navigationMenuSwitchLinks: Oi,
  navigationMenuSwitchLinksContent: Hi,
  navigationMenuSwitchLinksLink: Ai,
  navigationMenuSwitchLinksLinkActive: Ui,
  navigationMenuAccordion: Fi,
  navigationMenuAccordionHeading: Bi,
  navigationMenuAccordionHeadingContainer: Vi,
  navigationMenuAccordionHeadingLink: $i,
  navigationMenuAccordionHeadingIcon: ji,
  navigationMenuAccordionContent: Ki,
  navigationMenuAccordionContentEmployers: zi,
  navigationMenuAccordionContentContainer: Wi,
  navigationMenuFooter: Gi
};
function Yi(e) {
  const { links: n = [], closeMenu: t, switchLinks: a, currentPageId: i } = e, r = Ae(), s = Y();
  return /* @__PURE__ */ o.createElement(
    Ue,
    {
      className: U.navigationMenu,
      "data-testid": "menu-mobile",
      modalRef: r,
      closeModal: t
    },
    /* @__PURE__ */ o.createElement(Xi, { switchLinks: a, closeMenu: t }),
    /* @__PURE__ */ o.createElement(
      ke,
      {
        className: U.navigationMenuAccordion,
        defaultActiveId: i || n?.[0]?.id,
        collapsible: !0,
        "data-testid": "menu-mobile-accordion"
      },
      n?.filter((c) => c?.id !== fe)?.map(({ id: c, title: u, href: g, locale: l, subPages: p = [] }) => {
        const v = p.length === 0;
        return /* @__PURE__ */ o.createElement(
          ke.Item,
          {
            key: c,
            id: c,
            disabled: v,
            heading: ({ expanded: m }) => /* @__PURE__ */ o.createElement(
              qi,
              {
                expanded: m,
                href: g,
                locale: l,
                closeMenu: t,
                hideIcon: v
              },
              u
            )
          },
          v ? null : /* @__PURE__ */ o.createElement(
            T,
            {
              className: y(
                U.navigationMenuAccordionContent,
                s && U.navigationMenuAccordionContentEmployers
              ),
              topPadding: T.Padding.NONE,
              bottomPadding: T.Padding.NONE
            },
            /* @__PURE__ */ o.createElement(
              T.Content,
              {
                className: U.navigationMenuAccordionContentContainer
              },
              p.map((m) => /* @__PURE__ */ o.createElement(
                yi,
                {
                  key: m.id,
                  ...m,
                  closeMenu: t
                }
              ))
            )
          )
        );
      })
    )
  );
}
const Xi = ({
  switchLinks: e,
  closeMenu: n
}) => /* @__PURE__ */ o.createElement(
  T,
  {
    topPadding: T.Padding.NONE,
    bottomPadding: T.Padding.NONE,
    className: U.navigationMenuSwitchLinks
  },
  /* @__PURE__ */ o.createElement(T.Content, { flex: !0, className: U.navigationMenuSwitchLinksContent }, e.map((t) => /* @__PURE__ */ o.createElement(
    O,
    {
      key: t.id,
      href: t.href,
      onClick: t.isActive ? void 0 : n,
      className: y(
        U.navigationMenuSwitchLinksLink,
        t.isActive && U.navigationMenuSwitchLinksLinkActive
      ),
      disabled: t.isActive,
      disableLinkTextStyle: !0,
      itemProp: "url"
    },
    /* @__PURE__ */ o.createElement("span", { itemProp: "name" }, t.title)
  )))
);
function qi({
  expanded: e,
  children: n,
  href: t,
  locale: a,
  closeMenu: i,
  hideIcon: r
}) {
  return /* @__PURE__ */ o.createElement(T, { className: U.navigationMenuAccordionHeading }, /* @__PURE__ */ o.createElement(
    T.Content,
    {
      flex: !0,
      className: U.navigationMenuAccordionHeadingContainer
    },
    /* @__PURE__ */ o.createElement(
      O,
      {
        href: t,
        onClick: i,
        locale: a,
        title: n,
        disableLinkTextStyle: !0,
        className: y(
          U.navigationMenuAccordionHeadingLink,
          e ? z.headingSection : z.headingMenu
        ),
        itemProp: "url"
      },
      /* @__PURE__ */ o.createElement("span", { itemProp: "name" }, n)
    ),
    r ? null : /* @__PURE__ */ o.createElement(
      R,
      {
        className: U.navigationMenuAccordionHeadingIcon,
        icon: e ? N.CHEVRON_UP : N.CHEVRON_DOWN,
        size: 16
      }
    )
  ));
}
const Ji = "navigation__switch_link", Qi = "navigation__links_section", Zi = "navigation__links_section--mobile-only", ea = "desktop", na = "navigation__links_section__link", ta = "navigation__links_section__link--primary", oa = "navigation__links_section__link--secondary", ia = "navigation__links_section__link--mobile-only", aa = "navigation__modal", ra = "navigation__search", sa = "navigation__search__content", ca = "navigation__search__input", la = "navigation__search__input__label", da = "navigation__search__input__row", ua = "navigation__search__input__button", ga = "navigation__search__input__field", G = {
  navigationSwitchLink: Ji,
  navigationLinksSection: Qi,
  navigationLinksSectionMobileOnly: Zi,
  desktop: ea,
  navigationLinksSectionLink: na,
  navigationLinksSectionLinkPrimary: ta,
  navigationLinksSectionLinkSecondary: oa,
  navigationLinksSectionLinkMobileOnly: ia,
  navigationModal: aa,
  navigationSearch: ra,
  navigationSearchContent: sa,
  navigationSearchInput: ca,
  navigationSearchInputLabel: la,
  navigationSearchInputRow: da,
  navigationSearchInputButton: ua,
  navigationSearchInputField: ga
};
function va({
  defaultKeyword: e = "",
  closeSearch: n,
  renderContent: t,
  label: a,
  placeholder: i,
  clearLabel: r
}) {
  const s = Ae(), [c, u] = ee(e);
  return /* @__PURE__ */ o.createElement(
    Ue,
    {
      className: G.navigationSearch,
      "data-testid": "search",
      modalRef: s,
      closeModal: n
    },
    /* @__PURE__ */ o.createElement(T, { topPadding: be.NONE, bottomPadding: be.NONE }, /* @__PURE__ */ o.createElement(T.Content, { className: G.navigationSearchContent }, /* @__PURE__ */ o.createElement(
      _a,
      {
        onChange: u,
        defaultValue: e,
        label: a,
        placeholder: i,
        clearLabel: r
      }
    ))),
    t({ keyword: c, closeModal: n })
  );
}
function _a({
  onChange: e,
  defaultValue: n,
  placeholder: t = "For example: residence permit, housing, jobs",
  label: a = "Search the Work in Finland website",
  clearLabel: i = "Clear search"
}) {
  const r = he(), [s, c] = ee(n), [, u] = wn(), g = K(null), l = s.length > 0, p = $(() => {
    c(""), g.current?.focus();
  }, []);
  return ce(() => {
    u(() => e(s));
  }, [e, s]), ce(() => {
    g.current?.focus();
  }, []), /* @__PURE__ */ o.createElement(
    "div",
    {
      className: y(G.navigationSearchInput),
      "data-testid": "search-input"
    },
    /* @__PURE__ */ o.createElement(
      "label",
      {
        htmlFor: r,
        className: y(
          G.navigationSearchInputLabel,
          z.textsCaption
        )
      },
      a
    ),
    /* @__PURE__ */ o.createElement("div", { className: G.navigationSearchInputRow }, /* @__PURE__ */ o.createElement(
      "button",
      {
        type: "button",
        title: l ? i : a,
        "aria-label": l ? i : a,
        onClick: p,
        "data-testid": "search-input-button",
        className: G.navigationSearchInputButton
      },
      /* @__PURE__ */ o.createElement(R, { icon: l ? N.CLOSE : N.SEARCH, size: 24 })
    ), /* @__PURE__ */ o.createElement(
      "input",
      {
        id: r,
        type: "text",
        ref: g,
        value: s,
        onChange: (v) => c(v.target.value),
        placeholder: t,
        "data-testid": "search-input-field",
        className: y(
          G.navigationSearchInputField,
          z.textsComponentTitle
        )
      }
    ))
  );
}
function Pa(e) {
  const {
    isMenuOpen: n,
    isSearchOpen: t,
    toggleMenuOpen: a,
    toggleSearchOpen: i,
    closeMenu: r,
    closeSearch: s,
    closeAllModals: c
  } = ma();
  return /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
    oi,
    {
      ...e,
      isMenuOpen: n,
      onMenuClick: a,
      isSearchOpen: t,
      onSearchClick: i,
      onLogoClick: c
    }
  ), n ? /* @__PURE__ */ o.createElement(
    Yi,
    {
      links: e.links,
      switchLinks: e.switchLinks,
      closeMenu: r,
      currentPageId: e.currentPageId
    }
  ) : null, t ? /* @__PURE__ */ o.createElement(
    va,
    {
      closeSearch: s,
      renderContent: e.searchContent,
      defaultKeyword: e.defaultSearchKeyword,
      label: e.i18n?.searchLabel,
      placeholder: e.i18n?.searchPlaceholder,
      clearLabel: e.i18n?.clearSearchLabel
    }
  ) : null);
}
function ma() {
  const e = K(void 0), n = K(void 0), {
    isModalOpen: t,
    toggleModalOpen: a,
    closeModal: i
  } = Me({ onOpen: e.current }), {
    isModalOpen: r,
    toggleModalOpen: s,
    closeModal: c
  } = Me({ onOpen: n.current });
  n.current = i, e.current = c;
  const u = $(() => {
    i(), c();
  }, [i, c]);
  return {
    isMenuOpen: t,
    isSearchOpen: r,
    toggleMenuOpen: a,
    toggleSearchOpen: s,
    closeMenu: i,
    closeSearch: c,
    closeAllModals: u
  };
}
export {
  Pa as default
};
//# sourceMappingURL=Navigation.js.map
